import styled from 'styled-components';
import { ReactComponent as Search } from '../../../assets/icons/search.svg';
import Row from '../components/box/row';
import SizedBox from '../components/box/sizedBox';

interface BoxContainerProps {
  width?: number;
}

const BoxContainer = styled.div<BoxContainerProps>`
  padding: 11px;
  width: ${(props) => `${props.width}px`};
  border: ${(props) => `1px solid ${props.theme.colors.grayLine}`};
  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.white};

  &:has(input:focus) {
    border: ${(props) => `1px solid ${props.theme.colors.primary500}`};
  }
`;

const InnerInput = styled.input`
  width: 100%;
  border: none;
  font-size: 14px;
  font-family: 'Outfit';
  font-style: normal;
  color: ${(props) => props.theme.colors.body};

  &:focus {
    outline: none !important;
    border: none;
  }

  &::placeholder {
    font-size: 14px;
    font-family: 'Outfit';
    font-style: normal;
    color: ${(props) => props.theme.colors.placeHolder};
  }
`;

interface LXSearcherProps {
  value?: string;
  placeholder?: string;
  onChange: (val: string) => void;
  width?: number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const LXSearcher: React.FC<LXSearcherProps> = (props) => {
  return (
    <BoxContainer width={props.width}>
      <Row>
        <Search></Search>
        <SizedBox width={8}></SizedBox>
        <InnerInput
          {...props}
          onChange={(e) => props.onChange(e.target.value)}
        ></InnerInput>
      </Row>
    </BoxContainer>
  );
};

export default LXSearcher;
